import $store from '@/store'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import { getUserInfo } from '@/utils/auth'
import { getDepartmentByOfficeId, getOfficeConfigList } from '@/api/user'

import { cacheKeys as basicCacheKeys, getSpecificBasicData, basicDataCacheKeyPrefix } from './basicDataCache'

const configPenddingRequestMap = new Map()

// 缓存空间
const storage = new Map()
// 全局缓存开关 true开，false关
const GLOBAL_CACHE_SWITCH = true
/* 缓存数据名称 */
export const cacheName = {
  USER: 'user', // 用户
  OFFICE_LIST: 'officeList', // 公司列表
  OFFICE: 'office', // 公司
  DEPARTMENT: 'department', // 部门
  CONFIG: 'config', // 配置信息
  ...basicCacheKeys // 基础数据key
}

function basicCacheKeysForNull() {
  const nullResult = {}
  for (const key in basicCacheKeys) {
    nullResult[key] = null
  }
  return nullResult
}

// 获取指定的缓存基础数据
async function getCacheSpecificBasicData(key, reloadCache = GLOBAL_CACHE_SWITCH) {
  return await getSpecificBasicData(key, reloadCache)
}

function getOffice() {
  return $store.getters.currentOffice || {}
}

// 获取当前部门
async function getCurrentDepartment() {
  return $store.getters.currentDept || {}
}

/**
 * 获取公司配置
 * @param officeId 公司id
 * @param reloadCache 是否重新加载缓存
 * @returns {Promise<null>}
 */
export async function getConfig(officeId, reloadCache = GLOBAL_CACHE_SWITCH) {
  let config = !reloadCache ? storage.get(`${cacheName.CONFIG}/${officeId}`) : null
  if (!config) {
    let tempVal = configPenddingRequestMap.get(officeId)
    if (!tempVal) {
      configPenddingRequestMap.set(officeId, [])
      tempVal = configPenddingRequestMap.get(officeId)
      await getOfficeConfigList({ officeId }).then(res => {
        config = new Map()
        res.data.forEach(p => {
          config.set(p.configName, p.configValue || p.configParentValue || p.configDefValue)
        })
        storage.set(`${cacheName.CONFIG}/${officeId}`, config)
        // 总公司配置
        if (!storage.has('hqConfig')) {
          const hqConfig = new Map()
          for (const item of res.data) {
            hqConfig.set(item.configName, item.configParentValue || item.configDefValue)
          }
          storage.set('hqConfig', hqConfig)
        }
        for (const resolveTrigger of tempVal) {
          resolveTrigger(config)
        }
      }).finally(() => {
        configPenddingRequestMap.delete(officeId)
      })
      return config
    } else {
      let resolveTrigger = null
      const fakePromise = new Promise(function(resolve, reject) {
        resolveTrigger = resolve
      })
      tempVal.push(resolveTrigger)
      return fakePromise
    }
  }
  return config
}

export const cache = {
  user: null,
  officeList: null,
  office: null,
  department: null,
  config: null,
  hqConfig: null, // 总公司配置
  ...(basicCacheKeysForNull()),
  // 加载指定的缓存数据
  async load(...names) {
    const cacheOpts = names.map(name => {
      return { name, clear: false }
    })
    await this.reload([...cacheOpts])
  },
  // 清除缓存并重新加载
  async reload(cacheOpts) {
    // console.log('cacheOpts', cacheOpts)
    const officeId = $store.getters.currentOfficeId
    // await ensureExecuteSuccess(() => {
    //   officeId = $store.getters.currentOfficeId
    //   return !!officeId
    // })
    const promises = []
    for (const opt of cacheOpts) {
      /**
       * category 数据类别
       */
      const { name, clear, category } = { ...opt }// 入参结构
      if (category === 'basicData' || name.startsWith(basicDataCacheKeyPrefix)) { // 基础数据缓存
        promises.push(
          getCacheSpecificBasicData(name, clear).then(data => {
            this[name] = data
          })
        )
      } else {
        switch (name) {
          case cacheName.USER:
            this.user = getUserInfo()
            break
          case cacheName.OFFICE_LIST:
            this.officeList = getUserInfo().currentUserOfficeList
            break
          case cacheName.OFFICE:
            this.office = getOffice()
            break
          case cacheName.DEPARTMENT:
            this.department = getCurrentDepartment()
            break
          case cacheName.CONFIG:
            promises.push(
              getConfig(officeId, clear).then(data => {
                this.config = data
                this.hqConfig = storage.get('hqConfig')
              })
            )
            break
        }
      }
    }
    await Promise.all(promises)
  }
}
